var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.48352 7.97296C0.310329 7.79977 0.241053 7.59194 0.241053 7.34947C0.241053 7.14164 0.310329 6.93382 0.48352 6.76062L6.57984 0.941414C6.92622 0.629671 7.44579 0.629671 7.75753 0.976052C8.06928 1.2878 8.06928 1.84201 7.72289 2.15375L3.11602 6.51816H14.9276C15.3779 6.51816 15.7589 6.89918 15.7589 7.34947C15.7589 7.83441 15.3779 8.18079 14.9276 8.18079H3.11602L7.72289 12.5798C8.06928 12.8916 8.06928 13.4112 7.75753 13.7575C7.44579 14.1039 6.92622 14.1039 6.57984 13.7922L0.48352 7.97296Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.10f7097b3b32480f69be6dde5abf66ad.svg";
export { ForwardRef as ReactComponent };